exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProjectDetails-module__student-selector___2iU5k{width:200px;margin:2rem auto 0}", ""]);

// exports
exports.locals = {
	"student-selector": "ProjectDetails-module__student-selector___2iU5k"
};